import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    CustomersServiceProxy,
    CreateOrEditCustomerDto,
    CustomerPaymentTermLookupTableDto,
    CustomerPriceGroupLookupTableDto,
    CustomerLocationLookupTableDto,
    CustomerCurrencyLookupTableDto,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    templateUrl: './create-or-edit-customer.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditCustomerComponent extends AppComponentBase implements OnInit {
    active = false;
    saving = false;

    customer: CreateOrEditCustomerDto = new CreateOrEditCustomerDto();

    paymentTermName = '';
    priceGroupName = '';
    locationName = '';
    currencyName = '';

    allPaymentTerms: CustomerPaymentTermLookupTableDto[];
    allPriceGroups: CustomerPriceGroupLookupTableDto[];
    allLocations: CustomerLocationLookupTableDto[];
    allCurrencys: CustomerCurrencyLookupTableDto[];

    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('Customer'), '/app/sales/customers'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _customersServiceProxy: CustomersServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
    }

    show(customerId?: number): void {
        if (!customerId) {
            this.customer = new CreateOrEditCustomerDto();
            this.customer.id = customerId;
            this.paymentTermName = '';
            this.priceGroupName = '';
            this.locationName = '';
            this.currencyName = '';

            this.active = true;
        } else {
            this._customersServiceProxy.getCustomerForEdit(customerId).subscribe((result) => {
                this.customer = result.customer;

                this.paymentTermName = result.paymentTermName;
                this.priceGroupName = result.priceGroupName;
                this.locationName = result.locationName;
                this.currencyName = result.currencyName;

                this.active = true;
            });
        }
        this._customersServiceProxy.getAllPaymentTermForTableDropdown().subscribe((result) => {
            this.allPaymentTerms = result;
        });
        this._customersServiceProxy.getAllPriceGroupForTableDropdown().subscribe((result) => {
            this.allPriceGroups = result;
        });
        this._customersServiceProxy.getAllLocationForTableDropdown().subscribe((result) => {
            this.allLocations = result;
        });
        this._customersServiceProxy.getAllCurrencyForTableDropdown().subscribe((result) => {
            this.allCurrencys = result;
        });
    }

    save(): void {
        this.saving = true;

        this._customersServiceProxy
            .createOrEdit(this.customer)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/sales/customers']);
            });
    }

    saveAndNew(): void {
        this.saving = true;

        this._customersServiceProxy
            .createOrEdit(this.customer)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.customer = new CreateOrEditCustomerDto();
            });
    }

    goBack(): void {
        this._router.navigate(['/app/sales/customers']);
    }
}
